import { TrackJS } from 'trackjs';

const withErrorMeta = (meta: object = {}, fn: () => void) => {
  Object.entries(meta).forEach(([key, value]) => {
    const metaVal = JSON.stringify(value, null, 2);
    TrackJS.addMetadata(key, metaVal);
  });

  fn();

  Object.keys(meta).forEach((key) => {
    TrackJS.removeMetadata(key);
  });
};

export const trackError = (error: unknown, meta?: object) => {
  if (TrackJS.isInstalled()) {
    withErrorMeta(meta, () => {
      TrackJS.track(error as Error);
    });
  } else {
    let stack;
    if (error instanceof Error) {
      stack = error.stack;
    }

    if (!stack) {
      stack = new Error().stack;
    }
    console.error('Tracking:', error, JSON.stringify(meta, null, 2));
    console.error('Stack:', stack);
  }
};
